export default "__VITE_ASSET__CNZlDbOx__"